import { Controller } from "@hotwired/stimulus"
import Cleave from "cleave.js"

// Connects to data-controller="phone-mask"
// Uses Cleave.js for professional phone number masking
export default class extends Controller {
  connect() {
    console.log('Phone mask controller connected')

    this.cleave = new Cleave(this.element, {
      numericOnly: true,
      blocks: [3, 3, 4],
      delimiter: '-',
      delimiterLazyShow: true
    })

    console.log('Cleave initialized:', this.cleave)
  }

  disconnect() {
    if (this.cleave) {
      this.cleave.destroy()
    }
  }
}
